import { Button, Modal, Stack, TextInput } from "@mantine/core"
import { DatePickerInput } from "@mantine/dates"
import { useEffect, useState } from "react"
import dayjs from "dayjs"
import { useCreateEvent, useUpdateEvent } from "../hooks/use-events"

interface MSaveEventProps {
  opened: boolean
  onClose: () => void
  editingEvent: any | null
}

const emptyEvent = {
  nombre: "",
  fecha: "",
  lugar: "",
  descripcion: ""
}

export function MSaveEvent({ opened, onClose, editingEvent }: MSaveEventProps) {
  const [event, setEvent] = useState<typeof emptyEvent>(emptyEvent)
  const createEventMutation = useCreateEvent()
  const updateEventMutation = useUpdateEvent()

  useEffect(() => {
    if (editingEvent) {
      setEvent({
        nombre: editingEvent.nombre || "",
        fecha: editingEvent.fecha || "",
        lugar: editingEvent.lugar || "",
        descripcion: editingEvent.descripcion || ""
      })
    } else {
      setEvent(emptyEvent)
    }
  }, [editingEvent, opened])

  const handleSave = async () => {
    if (editingEvent) {
      await updateEventMutation.mutateAsync({ id: editingEvent.id, eventData: event })
    } else {
      await createEventMutation.mutateAsync(event)
    }
    onClose()
  }

  return (
    <Modal opened={opened} onClose={onClose} title={editingEvent ? "Editar Evento" : "Agregar Nuevo Evento"} centered>
      <Stack>
        <TextInput label="Nombre del evento" placeholder="Nombre" value={event.nombre} onChange={(e) => setEvent({ ...event, nombre: e.target.value })} required />
        <DatePickerInput label="Fecha" placeholder="Seleccione fecha" value={event.fecha ? dayjs(event.fecha).toDate() : null} onChange={(val) => setEvent({ ...event, fecha: val ? dayjs(val).format("YYYY-MM-DD") : "" })} required />
        <TextInput label="Lugar" placeholder="Lugar" value={event.lugar} onChange={(e) => setEvent({ ...event, lugar: e.target.value })} />
        <TextInput label="Descripción" placeholder="Descripción" value={event.descripcion} onChange={(e) => setEvent({ ...event, descripcion: e.target.value })} />
        <Button onClick={handleSave} loading={createEventMutation.isPending || updateEventMutation.isPending}>
          Guardar
        </Button>
      </Stack>
    </Modal>
  )
}
